define("shared/utils/create-flatpickr-config", ["exports", "@ember/debug", "@ember/utils", "flatpickr", "moment-timezone", "shared/utils/time-helpers/create-moment-in-tz", "later/models/flatpickr-config", "shared/utils/time-helpers/create-and-format-moment-in-tz"], function (_exports, _debug, _utils, _flatpickr, _momentTimezone, _createMomentInTz, _flatpickrConfig, _createAndFormatMomentInTz) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Mode = void 0;
  _exports.default = _default;
  _exports.toMoment = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"@ember/utils",0,"flatpickr",0,"moment-timezone",0,"shared/utils/time-helpers/create-moment-in-tz",0,"later/models/flatpickr-config",0,"shared/utils/time-helpers/create-and-format-moment-in-tz"eaimeta@70e063a35619d71f
  const Mode = _exports.Mode = {
    SINGLE: 'single',
    RANGE: 'range',
    MULTIPLE: 'multiple',
    TIME: 'time'
  };

  /**
   * Map between flatpickr and moment date formatting strings
   * all formats must be localized datetime strings without embedded timezone/offset information
   * timestamps are incompatible because flatpickr will use it to create its own date string in the wrong timezone
   */
  const toMoment = _exports.toMoment = {
    'Y/m/d h:i K': 'YYYY/MM/DD h:mm A',
    // 2021/01/08 1:12 AM
    'Y-m-dTG:i:S': 'YYYY-MM-DDTHH:mm:ss',
    // 2021-01-08T01:12:49
    'F j, Y': 'MMMM D, YYYY',
    // January 8, 2021
    'h:i K': 'h:mm A',
    // 1:12 AM
    'M j, Y': 'MMM D, YYYY',
    // Jan 8, 2021
    'Y-m-d': 'YYYY-MM-DD' // 2022-01-22
  };
  function isUnixTimeInSeconds(time) {
    return !!time && String(time).length === 10;
  }
  function formatDate(date, format) {
    const formatString = toMoment[format];
    if (formatString) {
      return (0, _momentTimezone.default)(date).format(formatString);
    }
    return _flatpickr.default.formatDate(date, format);
  }
  /**
   * Generates a flatpickr config object from passed in config.
   * For available options see: lib/shared/app/models/flatpickr-config.js
   */
  function _default(config, timezoneIdentifier) {
    const {
      dateFormat,
      dateTime,
      defaultDate,
      locale,
      ...rest
    } = config;
    (false && !((0, _utils.isPresent)(toMoment[dateFormat])) && (0, _debug.assert)('Must pass a valid date format that is a key in the toMoment obj', (0, _utils.isPresent)(toMoment[dateFormat])));
    let formattedDate;
    if (isUnixTimeInSeconds(dateTime)) {
      formattedDate = (0, _createMomentInTz.default)(Number(dateTime), timezoneIdentifier).format(toMoment[dateFormat]);
    } else if (defaultDate && Array.isArray(defaultDate) && isUnixTimeInSeconds(defaultDate[0])) {
      formattedDate = (0, _createAndFormatMomentInTz.default)(defaultDate, timezoneIdentifier, toMoment[dateFormat]);
    } else if (defaultDate === 'no-default') {
      formattedDate = new Date().getTime().toString();
    } else if (defaultDate) {
      formattedDate = defaultDate;
    } else {
      formattedDate = _momentTimezone.default.tz(new Date().getTime(), timezoneIdentifier).format(toMoment[dateFormat]);
    }
    return new _flatpickrConfig.default({
      ...rest,
      // our custom formatDate messes up the displayed date range if a non-english locale exists
      ...(!locale && {
        formatDate
      }),
      defaultDate: formattedDate,
      dateFormat,
      locale
    });
  }
});